// extracted by mini-css-extract-plugin
export var askAiIcon = "_mt-9";
export var container = "_mt-0";
export var groupSeparator = "_mt-a";
export var highlight = "_mt-4";
export var resultIcon = "_mt-5";
export var resultItem = "_mt-7";
export var resultSubtitle = "_mt-3";
export var resultTitle = "_mt-2";
export var resultsList = "_mt-1";
export var searchGroup = "_mt-6";
export var selected = "_mt-8";